// Copyright (c) 2016 Deere & Company

export default {
    onEnter: (nextState, replace) => replace('/'),
    path: '/*token*'
};



// WEBPACK FOOTER //
// ./src/routes/okta-callback.js